var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statistics-number",class:[
       _vm.type,
       {
         'retail' : _vm.isRetail,
         'played' : !_vm.isDrawnType,
       }]},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }